import type { Component } from "vue";
import { IQuickStartBonusCard } from "@/modules/bonuses-module/types";
import { IDocumentGroup } from "@/modules/documents-module/types";
import { RewardValues } from "@/modules/calculator-module/types";

export enum Regions {
  RUS = "RUS",
  KGZ = "KGZ",
  GHA = "GHA",
  UZB = "UZB",
}

export enum TariffId {
  FREE_C = "free_c",
  SMART_C = "smart_c",
  STANDARD_C = "standard_c",
  BUSINESS_D = "business_d",
  PREMIUM_D = "premium_d",
  BASE_D = "base_d",
  VIP_D = "vip_d",
  VIP_GOLD_D = "vip_gold_d",
}

export enum locales {
  KY = "ky",
  RU = "ru",
  EN = "en",
  UZ = "uz",
}

export enum currencies {
  RUB = "RUB",
  KGS = "KGS",
  GHS = "GHS",
  UZS = "UZS",
  KZT = "KZT",
  MDL = "MDL",
}

export interface ITariff {
  id: TariffId;
  icon: Component;
  color: string;
  generations?: number;
  info?: {
    franchisePlan?: { icon: Component; value: string };
    bonuses: { icon: Component; value: number };
    commission: { icon: Component; value: string };
  };
}

export type QualificationId =
  | "unqualified"
  | "start"
  | "expert"
  | "star"
  | "double_star"
  | "diamond"
  | "double_diamond"
  | "grand_diamond"
  | "diamond_elite"
  | "ambassador"
  | "v_president";

export interface IQualification {
  id: QualificationId;
  background: string;
  childQualifications?: Array<QualificationId>;
}

export interface ICountryQualificationRequirements {
  previousWeek?: number;
  currentWeek?: number;
  personallyInvitedL?: number;
  personallyInvitedR?: number;
  fromStart?: number;
  pv: number;
  lQualification?: QualificationId;
  rQualification?: QualificationId;
}

export interface ICountryQualificationBonuses {
  linearBonus?: boolean;
  leadershipBonus?: boolean;
  leadershipSecondBonus?: boolean;
  careerBonus?: number;
}

export interface ICountryQualification {
  requirements: ICountryQualificationRequirements;
  bonuses: ICountryQualificationBonuses;
}

export interface ICountry {
  auth: {
    source: string;
    passportUrl: string;
  };
  defaultLocale: locales;
  supportedLocales: locales[];
  currency: currencies;
  qualifications: {
    start: ICountryQualification;
    expert: ICountryQualification;
    star: ICountryQualification;
    double_star: ICountryQualification;
    diamond: ICountryQualification;
    double_diamond: ICountryQualification;
    grand_diamond: ICountryQualification;
    diamond_elite: ICountryQualification;
    ambassador: ICountryQualification;
    v_president: ICountryQualification;
  };
  quickStartBonus: IQuickStartBonusCard[];
  documents_groups: IDocumentGroup[];
  calculator: {
    partnerRewards: {
      [TariffId.BUSINESS_D]: {
        teamBonus: number;
      } & Partial<Record<TariffId, RewardValues>>;
      [TariffId.PREMIUM_D]: {
        teamBonus: number;
      } & Partial<Record<TariffId, RewardValues>>;
      [TariffId.VIP_D]: {
        teamBonus: number;
      } & Partial<Record<TariffId, RewardValues>>;
    };
    quickStartByTariff: {
      [TariffId.FREE_C]: number;
      [TariffId.SMART_C]: number;
      [TariffId.STANDARD_C]: number;
      [TariffId.BUSINESS_D]: number;
      [TariffId.PREMIUM_D]: number;
      [TariffId.VIP_D]: number;
      [TariffId.VIP_GOLD_D]: number;
    };
    teamBonusCoefficients: {
      [TariffId.FREE_C]: number;
      [TariffId.SMART_C]: number;
      [TariffId.STANDARD_C]: number;
      [TariffId.BUSINESS_D]: number;
      [TariffId.PREMIUM_D]: number;
      [TariffId.VIP_D]: number;
      [TariffId.VIP_GOLD_D]: number;
    };
  };
}

export interface ICountries {
  KG: ICountry;
  GH: ICountry;
  UZ: ICountry;
}
